import { render, staticRenderFns } from "./course_index.vue?vue&type=template&id=00e078c5&scoped=true"
import script from "./course_index.vue?vue&type=script&lang=js"
export * from "./course_index.vue?vue&type=script&lang=js"
import style0 from "./course_index.vue?vue&type=style&index=0&id=00e078c5&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e078c5",
  null
  
)

export default component.exports